"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _InstallationPanel = require("./InstallationPanel");

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isNoteCreationSettingEnabled = _ref.isNoteCreationSettingEnabled,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      onSettingChanged = _ref.onSettingChanged,
      showActionButtons = _ref.showActionButtons,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isSavingNoteCreationSetting = _ref.isSavingNoteCreationSetting;
  var NoteCreationIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Create Productboard notes from community posts',
    toggleLabel: 'Enable moderators to create Productboard notes',
    isInstalled: isInstalled,
    isSettingEnabled: isNoteCreationSettingEnabled,
    storedIsSettingEnabled: storedState.isNoteCreationSettingEnabled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'productboard-s',
    description: 'Create a Productboard note from any user-generated content (ideas, questions, conversations, replies) via Control.',
    onSave: onSave,
    onCancel: onCancel,
    onSettingChanged: onSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-productboard-note-creation',
    communityArticleLink: 'https://community.insided.com/integrations-124/guide-how-to-set-up-and-use-the-insided-x-productboard-integration-3623',
    additionalHelpText: (0, _preact.h)("span", null, "Open a topic from the ", (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "_blank",
      rel: "noreferrer",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/overview")
    }, "content overview"), " and click the Productboard logo next to any user-generated content to create a ticket."),
    isLoading: isSavingNoteCreationSetting
  });
  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: [NoteCreationIntegrationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      accessToken = _ref2.accessToken,
      onClickManage = _ref2.onClickManage,
      onChangeCallback = _ref2.onChangeCallback,
      onClickCallback = _ref2.onClickCallback,
      errorMessage = _ref2.errorMessage,
      onClickUninstall = _ref2.onClickUninstall,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges,
      isSavingCredentials = _ref2.isSavingCredentials;
  var InstallationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onCancel: onCancel,
    onChangeCallback: onChangeCallback,
    onClickCallback: onClickCallback,
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall,
    accessToken: accessToken,
    errorMessage: errorMessage,
    isSavingCredentials: isSavingCredentials,
    hasUnsavedChanges: hasUnsavedChanges
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [InstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Productboard integration step by step",
    url: "https://community.insided.com/integrations-124/guide-how-to-set-up-and-use-the-insided-x-productboard-integration-3623",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;